<template>
  <div>
    <Head title="Dashboard" />
    <h1 class="mb-8 text-3xl font-bold">Статистика за сегодня</h1>
    <div class="flex flex-wrap m-8">
      <h1 class="mb-8 mr-8 text-2xl font-bold">
        <Link class="text-indigo-400 hover:text-indigo-600" href="/trips">Места / Занято:</Link> {{ today.seat_counter }} / {{ today.used_seat_counter }}
      </h1>
      <h1 class="mb-8 mr-8 text-2xl font-bold">
        <Link class="text-indigo-400 hover:text-indigo-600" href="/trips">Клиенты:</Link> {{ today.client_counter }}
      </h1>
      <h1 class="mb-8 mr-8 text-2xl font-bold">
        <Link class="text-indigo-400 hover:text-indigo-600" href="/trips">Поездки:</Link> {{ today.trip_counter }}
      </h1>
      <h1 class="mb-8 mr-8 text-2xl font-bold">
        <Link class="text-indigo-400 hover:text-indigo-600" href="/cars">Авто в работе:</Link> {{ today.car_counter }}
      </h1>
      <h1 class="mb-8 mr-8 text-2xl font-bold">
        <Link class="text-indigo-400 hover:text-indigo-600" href="#">Сборы:</Link> {{ today.sum }}р.
      </h1>
      <h1 class="mb-8 mr-8 text-2xl font-bold">
        <Link class="text-indigo-400 hover:text-indigo-600" href="/clients">Новые клиенты:</Link> {{ today.new_client_counter }}
      </h1>
    </div>
    <h1 class="mb-8 text-3xl font-bold">Поездки</h1>
    <div v-for="(dayWithTrips, tripDate) in trips" :key="tripDate">
      <div class="text-2xl text-left font-bold">{{ tripDate }}</div>
      <div class="mt-5">
        <div v-for="trip in dayWithTrips" :key="trip.id" class="py-4">
          <Link :href="`/trips/${trip.id}/edit`" class="text-indigo-400">
            <span class="font-bold">{{ trip.trip_time }}</span> #<span class="font-bold">{{ trip.id }}</span>
          </Link> |
          <span>{{ trip.route.departure }}</span> - <span>{{ trip.route.destination }}</span>,
          {{ trip.car.mark }} {{ trip.car.model }} {{ trip.car.color }}, {{ trip.price }}р.
          (<span v-if="trip.available_seats === 0">Мест нет</span>
          <span v-if="trip.available_seats > 0">мест: {{ trip.available_seats }}</span>)
          <Link v-if="trip.awaits_count > 0" :href="`/trips/${trip.id}/edit#awaits`" class="font-bold" style="color:red">ЖДУТ: {{ trip.awaits_count }}</Link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {Head, Link} from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'

export default {
  components: {
    Head,
    Link,
  },
  layout: Layout,
  props: {
    today: Object,
    trips: Array,
  },
}
</script>
